<template>
  <div class="label_component">
    <div class="left_right_icon left" @click="() => toRight(1)">
      <a-icon type="left" style="color: #168DFF" />
    </div>
    <div class="content_box" ref="labelComponent">
      <ul class="all_label_box" ref="allLabelBox" :style="{ left: `${left}px` }">
        <li
          class="label_box"
          v-if="label.title !== '欢迎页'"
          v-for="(label, index) in labelList"
          :key="index"
          :class="{ select: $route.name === label.name }"
          @click="onclick(label)"
        >
          <div class="label_box_title">
            <span>{{ label.title }}</span>
          </div>
          <a-icon
            type="close"
            @click.stop="onRemove(index, label.name)"
          />
        </li>
      </ul>
    </div>
    <div class="left_right_icon right" @click="() => toLeft(1)">
      <a-icon type="right" style="color: #168DFF" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { _menuList, bus } from "./util";
import config from "./config";

export default {
  name: "Label",
  props: {
    left: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      labelComponentWidth: 0,
      allLabelBoxWidth: 0,
      pcs: 0,
      selectIndex: 0
    };
  },
  computed: {
    ...mapState(["labelList"])
  },
  created() {
    //console.log(config, 'config')
    this.dealLabel();
    // 监听关闭当前页面
    bus.$on("close_current_page", () => {
      const route = this.$route;
      const labelList = this.labelList.concat();
      const index = this.labelList.findIndex(item => {
        return item.name === route.name;
      });
      this.onRemove(index, labelList[index].name);
    });
  },
  mounted() {
    this.getCompoentWidth();
  },
  methods: {
    getCompoentWidth() {
      this.labelComponentWidth = this.$refs?.labelComponent?.offsetWidth;
      this.allLabelBoxWidth = this.$refs?.allLabelBox?.offsetWidth;
      this.pcs = Math.ceil(this.labelComponentWidth / 240 || 0);
    },
    onclick(routerName) {
      this.$router.push(routerName.path);
    },
    dealLabel() {
      const labelList = this.labelList;
      const route = this.$route;
      let routeIndex = -1;
      // console.log(route, 'route')
      // 判断是否需要全部展示
      // if (config.showlabel == "MENU") {
      //   const flag = _menuList.find(item => {
      //     return `/${item.path}` === route.path;
      //   });
      //   console.log(flag);
      //   if (!flag) {
      //     return;
      //   }
      // }
      const flag = labelList.find((item, index) => {
        routeIndex = index;
        return item.name === route.name;
      });
      let obj = {
        path: route.fullPath,
        title: route.meta.title,
        name: route.name
      };
      if (!flag) {
        labelList.unshift(obj);
      } else {
        if (routeIndex >= this.pcs) {
          this.toLeft((routeIndex - this.pcs) + 1);

        } else {
          this.toRight(this.selectIndex);
        }
        labelList.splice(routeIndex, 1, obj);
      }
      this.selectIndex = routeIndex; // 当前选中的下标
      this.$store.commit("SET_LABELLIST", labelList);

    },


    onRemove(index, name) {
      const labelList = this.labelList;
      if (this.$route.name !== name) {
        labelList.splice(index, 1);
        this.$store.commit("SET_LABELLIST", labelList);
        return;
      }
      if (index - 1 > -1) {
        this.$router.push(labelList[index - 1].path);
      } else {
        if (labelList.length > 1) {
          this.$router.push(labelList[index + 1].path);
        } else {
          this.$router.push("/home");
        }
      }
      labelList.splice(index, 1);
      this.$store.commit("SET_LABELLIST", labelList);
      this.dealLeft();
    },
    dealLeft() {
      this.getCompoentWidth();
      const difference = this.allLabelBoxWidth - this.labelComponentWidth;
      if (difference < 0) {
        this.$emit("update:left", 0);
      }
    },
    toLeft(pcs = 0) {
      this.getCompoentWidth();
      const difference = this.allLabelBoxWidth - this.labelComponentWidth;
      if (difference > 0) {
        let left = this.left - 240 * (pcs || 0);
        if (Math.abs(left) > difference) {
          left = -difference;
        }
        this.$emit("update:left", left);
      }
    },
    toRight(pcs = 0) {
      this.getCompoentWidth();
      const difference = this.allLabelBoxWidth - this.labelComponentWidth;
      if (difference > 0) {
        let left = this.left + 240 * (pcs || 0);
        if (left > 0) {
          left = 0;
        }
        this.$emit("update:left", left);
      }
    }
  },
  watch: {
    $route: function() {
      this.dealLabel();
    }
  }
};
</script>

<style lang="less" scoped>
@baseColor: #168DFF;
.label_component {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);

  ul, li {
    padding: 0;
  }

  .left_right_icon {
    width: 30px;
    height: 100%;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }

    .anticon {
      line-height: 43px;
    }

    &.left {
      position: absolute;
      left: 0;
      top: 0;
    }

    &.right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  .content_box {
    position: absolute;
    left: 30px;
    right: 30px;
    top: 0;
    bottom: 0;
    height: 100%;
    overflow: hidden;

    .all_label_box {
      height: 100%;
      white-space: nowrap;
      display: inline-flex;
      transition: all 0.3s;
      position: absolute;
      top: 0;

      .label_box {
        float: left;

        height: 100%;
        width: 240px;
        position: relative;
        line-height: 43px;
        cursor: pointer;
        color: #999999;
        font-size: 14px;
        background: #f4f4f4;

        &_title {
          height: 100%;
          display: block;
          width: 90%;
          font-weight: bold;
          position: relative;
          text-align: center;

          span {
            width: 100%;
            text-overflow: ellipsis;
          }
        }

        .anticon {
          position: absolute;
          right: 10px;
          top: 15px;
          color: @baseColor;
          opacity: 1;
          font-size: 12px;
          transition: all 0.3s;
        }

        &:hover {
          color: @baseColor;

          .anticon {
            opacity: 1;
          }
        }

        &.select {
          color: @baseColor;
          background: #fff;

          .label_box_title::after {
            content: "";
            width: 60px;
            height: 3px;
            background: @baseColor;
            position: absolute;
            bottom: 0px;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }

      &::after {
        content: " ";
        display: block;
        height: 0;
        font-size: 0;
      }
    }
  }
}
</style>
